import React from 'react';
import './CustomTabPanel.scss';


interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const CustomTabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      className="CustomTabPanel"
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <div className="CustomTabPanelContent">
          {children}
        </div>
      )}
    </div>
  );
};

export default CustomTabPanel;